export default "__VITE_ASSET__CD0UWg9g__"